import { render, staticRenderFns } from "./LogoutView.vue?vue&type=template&id=0ee18166&scoped=true"
import script from "./LogoutView.vue?vue&type=script&lang=ts"
export * from "./LogoutView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee18166",
  null
  
)

export default component.exports